export enum MainAccessEntity {
  ADDRESS = 'addresses',
  ADDRESS_WASH_DETAIL = 'addressWashDetails',
  ALL_DEPARTMENT_GROUP = 'allDepartmentGroups',
  ALL_DEPARTMENTS = 'allDepartments',
  ARTICLE_PRICE_OVERRIDE = 'articlePriceOverrides',
  BANNER = 'banners',
  COMMAND_RESULT = 'commandResults',
  CONSIGNMENT = 'consignments',
  CONSIGNMENT_EVENT = 'consignmentEvents',
  CONSIGNMENT_EVENT_ACTION = 'consignmentEventActions',
  CONSIGNMENT_PRE_ADVICE = 'consignmentPreAdvices',
  COURIER_LOCATION = 'courierLocations',
  COURIER_SCAN_RESULT = '',
  CUSTOMER = 'customers',
  CUSTOMER_EVENT_EMAIL = 'customerEventEmails',
  CUSTOMER_GROUP = 'customerGroups',
  CUSTOMER_WITH_THEME = 'customerWithThemes',
  CUSTOM_MEASUREMENT = 'customMeasurements',
  DANGEROUS_GOODS = 'dangerousGoods',
  DELETED_CONSIGNMENT = 'deletedConsignments',
  DELETED_CONSIGNMENT_EVENT = 'deletedConsignmentEvents',
  DELETED_ORDER = 'deletedOrders',
  DELETED_ORDER_NOTE = 'deletedOrderNotes',
  DELIVERY_META_DATA = 'deliveryMetaDatas',
  DELIVERY_WINDOW = 'delivery_window',
  DEPARTMENT = 'departments',
  DEPARTMENT_GROUP = 'departmentGroups',
  DEPARTMENT_TIME_WINDOW = 'departmentTimeWindows',
  DISABLE_JOB = 'disableJobs',
  ENABLE_JOB = 'enableJobs',
  ETA = 'etas',
  EXPORT_DEPARTMENT_DATA_EXECUTION = 'exportDepartmentDataExecutions',
  FOLLOWUP_QUERY_METADATA = 'followupQueryMetadatas',
  I18N_TEXT = 'i18nTexts',
  IMPORT_DEPARTMENT_DATA_EXECUTION = 'importDepartmentDataExecutions',
  IMPORT_RESULT = 'importResults',
  IMPORT_STATUS = 'importStatuses',
  INVOICE_ITEM = 'invoiceItems',
  INVOICING_STATUS_COUNT = 'invoicingStatusCounts',
  LABEL_URL = 'labelUrls',
  MOBILE_APP_SETTING = 'mobileAppSetting',
  MOVE_ORDERS_ERROR = 'moveOrdersErrors',
  MULTISTOP_DETAIL = 'multistopDetails',
  OPERATING_UNIT = 'operatingUnits',
  OPTIMIZE_JOB_RESULT = 'optimizeJobResults',
  ORDER = 'orders',
  ORDER_CORRECTION = 'orderCorrections',
  ORDER_DEVIATION = 'orderDeviations',
  ORDER_EVENT_EMAIL = 'orderEventEmails',
  ORDER_INVOICING_EXECUTION = 'orderInvoicingExecutions',
  ORDER_NOTE = 'orderNotes',
  ORDER_PRE_ADVICE_STATUS_COUNT = 'orderPreAdviceStatusCounts',
  ORDER_RETURN_DETAIL = 'orderReturnDetails',
  ORDER_RETURN_STATUS_COUNT = 'orderReturnStatusCounts',
  PLANNED_STOP = 'plannedStops',
  PLANNED_STOP_LOCATION = 'plannedStopLocations',
  PRE_ADVICE_POLICY = 'preAdvicePolicies',
  PRE_ADVICE_SERVICE_POLICY = 'preAdviceServicePolicies',
  PRICE_UPDATE = 'priceUpdates',
  PRODUCTION_TIME_WINDOW = 'productionTimeWindows',
  RECURRING_ORDER = 'recurringOrders',
  RECURRING_ORDER_EXECUTION = 'recurringOrderExecutions',
  ROLE = 'roles',
  ROUTE_POINT = 'routePoints',
  ROUTE_POINT_SUGGESTION = 'routePointSuggestions',
  SAME_COUNTRY_DEPARTMENTS = 'sameCountryDepartments',
  SEARCH_DELETED_ORDER = 'searchDeletedOrders',
  SEND_SMS = 'sendSms',
  SERVICE_TIME_MATRIX = 'serviceTimeMatrixs',
  SLOT = 'slots',
  SLOT_METRIC = 'slotMetrics',
  SLOT_PROGRESS = 'slotProgress',
  TEMPLATE = 'templates',
  TEMPLATE_SLOT = 'templateSlots',
  TEMPLATE_ROUTE = 'templateRoutes',
  TEMPLATE_ROUTE_RULE = 'templateRouteRules',
  TEMPLATE_SHIPMENT = 'templateShipments',
  TEMPLATE_PACKAGE = 'templatePackages',
  TEMPLATE_EXCEPTION = 'templateExceptions',
  TEMPLATE_PLANNED_STOP = 'templatePlannedStops',
  TEXT = 'texts',
  THEME = 'themes',
  UNCONFIRMED_ORDER_SEARCH = 'unconfirmedOrderSearchs',
  UNIT = 'units',
  UNIT_DEFAULT_VEHICLE = 'unitDefaultVehicles',
  UPSALES_RULE = 'upsalesRules',
  USER = 'users',
  VEHICLE = 'vehicles',
  VENDOR = 'vendors',
  VENDOR_SITE = 'vendorSites',
  WAYBILLS_REQUEST = 'waybillsRequests',
  WEBHOOK_SUBSCRIPTION = 'webhookSubscriptions',
  WHATS_THIS = 'whatsThis'
}

export type MainAccessType = keyof typeof MainAccessEntity
